import TeacherCard from '../../components/TeacherCard';
export default {
  components: {
    TeacherCard
  },
  props: {
    baseInfo: Object,
    menu: Object
  },

  created() {
    this.getTeachData();
  },

  data() {
    return {
      dataList: [] //   bgImage: require(`../../../assets/images/home/data_display_bg.jpg`)

    };
  },

  methods: {
    async getTeachData() {
      const list = await this.$http.getTeachData({
        num: this.menu.num
      });
      console.log('首页-数据展示', list);
      this.dataList = this.handleUrl(list);
    },

    handleUrl(data) {
      const urlList = {
        10301: '/index.html?',
        10401: '/courseList.html?type=1&',
        10402: '/courseList.html?type=2&',
        10501: '/teacherList.html?',
        10601: '/live.html?',
        10701: '/notice.html?',
        51001: '/teachingCenterList.html?',
        13100: '/microSpecialtyList.html?',
        40005: '/lectureList.html?',
        17100: '/train.html?'
      }; // 点击导航跳转到对应taget_url,并传参

      const list = data.map(item => ({ ...item,
        targetUrl: item.template == 1 ? item.targetUrl : item.template == 2 && item.targetUrl ? `${urlList[item.functionId]}menuId=${item.menuId}&name=${item.name}` : ''
      }));
      return list;
    }

  }
};